import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

const NIP_PATTERN = /^\d{10}$/;
const INVALID_NIP_VALUES = new Set(['0000000000']);

function validatePolishNipChecksum(nip: string): boolean {
  if (nip.length !== 10) return false;
  if (INVALID_NIP_VALUES.has(nip)) return false;
  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(nip[i]!, 10) * weights[i]!;
  }
  const checksum = sum % 11;
  if (checksum === 10) return false;
  return parseInt(nip[9]!, 10) === checksum;
}

export function nipChecksumValidator(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || raw === '') return null;
  const nip = String(raw).replace(/\D/g, '');
  if (nip.length !== 10) return null;
  if (!validatePolishNipChecksum(nip)) return { nipChecksum: true };
  return null;
}

export const nipValidators: ValidatorFn[] = [
  Validators.required,
  Validators.pattern(NIP_PATTERN),
  Validators.maxLength(10),
  nipChecksumValidator
];

export { NIP_PATTERN };
